import React from 'react'

import educationTimeline from '../../../js/homepage/educationTimeline'

const EducationCard = () => {
  return (
    <section id="EducationCard" className="education-section">
      {educationTimeline.map((edu) => (
        <div className="edcard-wrap" key={edu.id}>
          <div className="edcard-topwrap">
            <div className="edu-logo">
              <img src={edu.logo || '/placeholder-logo.png'} alt={`${edu.location} Logo`} />
            </div>
            <div className="edu-detail">
              <h1 className="edu-degree">
                {edu.title}
              </h1>
              <h2 className="institution-name">
                {edu.location}
              </h2>
              <h3 className="institution-period">
                {edu.date}
              </h3>
              <h3 className="institution-location">
                {edu.gpa}
              </h3>
            </div>
          </div>
          <p className="institution-description">
            {edu.description}
          </p>
        </div>
      ))}
    </section>
  )
}

export default EducationCard
